import React from 'react';

import { isEmptyString } from 'Shared/helpers';

import MeetingsListItem from 'Shared/components/modals/SimpleAddWorkspaceModals/SuggestionsSection/MeetingsListItem/MeetingsListItem';

import './WorkspaceNameSuggestions.scss';

type Props = {
  isSuggestionOpened: boolean;
  workspaceName: string;
  recurringMeetings: Array<{
    id: number;
    name: string;
    attendees: Array<{
      email: string;
      fullName: string;
    }>;
  }>;
  onSuggestionClick: Function;
};

function WorkspaceNameSuggestions({ isSuggestionOpened, workspaceName, recurringMeetings, onSuggestionClick }: Props) {
  const renderList = recurringMeetings.filter(({ name }) => name.toLowerCase().includes(workspaceName.toLowerCase()));
  const isRender = isSuggestionOpened && !isEmptyString(workspaceName) && renderList.length;

  if (!isRender) return null;

  return (
    <div className="workspace-name-suggestions position-relative">
      <div className="workspace-name-suggestions-container position-absolute scrollbar w-100">
        <div className="workspace-name-suggestions-title p-2">Suggestions:</div>
        {renderList.map(meeting => (
          <MeetingsListItem
            key={meeting.id}
            id={meeting.id}
            name={meeting.name}
            attendees={meeting.attendees}
            onClick={() => {
              onSuggestionClick({
                name: meeting.name,
                emails: meeting.attendees.map(({ email }) => ({ value: email, label: email })),
                recurringMeetingId: meeting.id,
              });
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default WorkspaceNameSuggestions;
